
import type { IUserProfile } from "src/types/user";

import { hasSuperUserOrBetaAccess } from "src/auth/utils/permissions";

import type { navData } from "../config-nav-dashboard";

export function filterDashboardNavForUser(sections: typeof navData.main, userProfile: IUserProfile | null) {
  return sections.map((section) => ({
    ...section,
    items: section.items.filter((item) => {
      if ('adminOnly' in item && item.adminOnly) return hasSuperUserOrBetaAccess(userProfile ?? null);
      return true;
    }),
  }));
}